/** Requirement and visibility are separate: optional data can still be relevant. */
export type FieldApplicability = 'required' | 'requested' | 'optional' | 'not-applicable';
export type FieldVisibility = 'primary' | 'additional' | 'hidden';

export function fieldVisibility(applicability: FieldApplicability, hasAnswer: boolean): FieldVisibility {
  if (applicability === 'required' || applicability === 'requested' || hasAnswer) return 'primary';
  return applicability === 'optional' ? 'additional' : 'hidden';
}
